// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"df2f588b","370":"4e6cc983","437":"d9087213","471":"a7ee2b27","535":"63b6c2ca","551":"f6853bd6"}[chunkId] + ".chunk.js";
};